import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router";
import { HINTS, Icon, useHelpItems } from "./nav";

/** Botón flotante «Solicitudes»: consejería, bautismos, presentación de niños, mantenimiento y guardería. */
export function HelpButton() {
  const items = useHelpItems();
  const [open, setOpen] = useState(false);
  // Mientras la persona baja por la página se hace pequeño (solo el ícono) para no tapar botones.
  const [small, setSmall] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  const { pathname, search } = useLocation();
  // Al cambiar de página se cierra solo.
  useEffect(() => setOpen(false), [pathname, search]);
  // Se cierra al tocar fuera o con Esc.
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);
  useEffect(() => {
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (Math.abs(y - last) < 8) return;
      setSmall(y > last && y > 80);
      last = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  // En Mi familia y al proyectar ocupa espacio que no le toca.
  if (
    items.length === 0 ||
    pathname.startsWith("/app/hogar") ||
    pathname.includes("/proyectar")
  )
    return null;
  const compact = small && !open;
  return (
    <div className={`help-fab${compact ? " help-fab--small" : ""}`} ref={box}>
      {open ? (
        <div className="help-fab__panel" role="dialog" aria-label="Solicitudes">
          <p className="help-fab__title">¿Qué necesitas pedir?</p>
          <ul>
            {items.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="help-fab__item">
                  <Icon name={item.icon} />
                  <span>
                    <strong>{item.label}</strong>
                    {HINTS[item.to] ? (
                      <span className="small muted">{HINTS[item.to]}</span>
                    ) : null}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      <button
        type="button"
        className="help-fab__button"
        aria-expanded={open}
        aria-label={open ? "Cerrar" : "Solicitudes"}
        onClick={() => setOpen((v) => !v)}
      >
        {compact ? <Icon name="inbox" /> : open ? "Cerrar" : "Solicitudes"}
      </button>
    </div>
  );
}
